// extracted by mini-css-extract-plugin
export default {"checkboxList":"role-select_checkboxList__e37pj"};